import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'

import { getQuestionnaireArtifactPreviewUrl } from '@/gen/questionnaire/v2/questionnaire-QuestionnaireService_connectquery'
import { QuestionnaireService } from '@/gen/questionnaire/v2/questionnaire_pb'

import { defaultTransport } from '@/lib/connect/connect-transport'

export const getGetQuestionnaireArtifactPreviewUrlQueryKey = (
  questionnaireArtifactId: string,
  filename: string,
) =>
  createConnectQueryKey({
    schema: QuestionnaireService.method.getQuestionnaireArtifactPreviewUrl,
    input: { questionnaireArtifactId, filename },
    transport: defaultTransport,
    cardinality: 'finite',
  })

// --- Hooks ---

export const useGetQuestionnaireArtifactPreviewUrl = ({
  questionnaireArtifactId,
  filename,
}: {
  questionnaireArtifactId: string
  filename: string
}) => {
  const queryState = useQuery(
    getQuestionnaireArtifactPreviewUrl,
    { questionnaireArtifactId, filename },
    {
      staleTime: 300000, // 5 minutes it's the expiration time of the preview URL
    },
  )

  return { ...queryState, previewUrl: queryState.data?.previewUrl }
}
